import {
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
  type SnapshotOptions,
  Timestamp,
} from 'firebase/firestore';
import type { BlockSubtype } from '@modules/shared-types';

function toTimestamp(value: Date | string | null | undefined): Timestamp | null | undefined {
  if (value === null) return null;
  if (value === undefined) return undefined;
  return Timestamp.fromDate(value instanceof Date ? value : new Date(value));
}

export const blockSubtypeConverter: FirestoreDataConverter<BlockSubtype> = {
  toFirestore(value: BlockSubtype) {
    const { id: _id, ...data } = value;
    return {
      ...data,
      createdAt: toTimestamp(data.createdAt),
      updatedAt: toTimestamp(data.updatedAt),
    };
  },

  fromFirestore(snapshot: QueryDocumentSnapshot, options?: SnapshotOptions): BlockSubtype {
    const data = snapshot.data(options);
    return {
      ...data,
      id: snapshot.id,
      // C6' additive field: legacy docs predate screenExamples.
      screenExamples: data.screenExamples ?? [],
      createdAt: data.createdAt?.toDate?.() ?? data.createdAt ?? null,
      updatedAt: data.updatedAt?.toDate?.() ?? data.updatedAt ?? null,
    } as BlockSubtype;
  },
};
